import { APPLICATIONS } from "@zhihaoscm/meta";
export interface AUTH_OPTION {
    label: string;
    auth: string;
    checkout?: boolean;
}

export interface AUTH {
    label: string;
    auth?: string;
    checkout?: boolean;
    indeterminate?: boolean;
    children?: Array<AUTH>;
    authOptions?: Array<AUTH_OPTION>;
}

// 1收集每个路由所有的子孙节点
export interface Permission {
    label: string;
    auth?: string;
    checkout?: boolean;
    indeterminate?: boolean;
    children?: Array<Permission>;
    allChildren?: Array<Permission>;
    parent?: Permission | null;
    row?: number;
    col?: number;
    rowspan?: number;
    colspan?: number;
    authOptions?: Array<AUTH_OPTION>;
    newChildren?: Permission[][];
}
export const applicationList: Array<AUTH> = [
    {
        label: "全选",
        children: [
            {
                label: "查船",
                authOptions: [
                    {
                        label: "船舶信息",
                        auth: APPLICATIONS.FUND_SHIP_INFO.code
                    },
                    {
                        label: "船舶动态信息",
                        auth: APPLICATIONS.FUND_SHIP_DYNAMIC_INFO.code
                    },
                    {
                        label: "船舶轨迹",
                        auth: APPLICATIONS.FUND_SHIP_ROUTE_INFO.code
                    },
                    {
                        label: "船舶设备信息",
                        auth: APPLICATIONS.FUND_SHIP_DEVICE_INFO.code
                    }
                ]
            },
            {
                label: "查车",
                authOptions: [
                    {
                        label: "车辆信息",
                        auth: APPLICATIONS.FUND_CAR_INFO.code
                    },
                    {
                        label: "车辆动态信息",
                        auth: APPLICATIONS.FUND_CAR_DYNAMIC_INFO.code
                    },
                    {
                        label: "车辆轨迹",
                        auth: APPLICATIONS.FUND_CAR_ROUTE_INFO.code
                    },
                    {
                        label: "车辆设备信息",
                        auth: APPLICATIONS.FUND_CAR_DEVICE_INFO.code
                    }
                ]
            },
            {
                label: "摄像头",
                authOptions: [
                    {
                        label: "直播",
                        auth: APPLICATIONS.CAMERA_LIVE.code
                    },
                    {
                        label: "视频回放",
                        auth: APPLICATIONS.CAMERA_BACK_VIEW.code
                    }
                ]
            },
            {
                label: "船运需求",
                authOptions: [
                    {
                        label: "推送船运需求发布",
                        auth: APPLICATIONS.SHIP_TRANSFER_PUSH_REQUIREMENT_PUBLISH.code
                    },
                    {
                        label: "推送船运单",
                        auth: APPLICATIONS.SHIP_TRANSFER_PUSH_REQUIREMENT_BILL.code
                    },
                    {
                        label: "接入找船需求",
                        auth: APPLICATIONS.SHIP_TRANSFER_CONNECT_REQUIREMENT.code
                    },
                    {
                        label: "接入船运单",
                        auth: APPLICATIONS.SHIP_TRANSFER_CONNECT_TRANSPORT_BILL.code
                    }
                ]
            },
            {
                label: "OCR模型",
                authOptions: [
                    {
                        label: "身份证",
                        auth: APPLICATIONS.OCR_ID_CARD.code
                    },
                    {
                        label: "驾驶证",
                        auth: APPLICATIONS.OCR_DRIVER_LICENSE.code
                    },
                    {
                        label: "从业资格证",
                        auth: APPLICATIONS.OCR_QUALIFICATION_CERTIFICATE.code
                    },
                    {
                        label: "行驶证",
                        auth: APPLICATIONS.OCR_DRIVING_LICENSE.code
                    },
                    {
                        label: "道路运输证",
                        auth: APPLICATIONS.OCR_ROAD_TRANSPORT_CERTIFICATE.code
                    },
                    {
                        label: "银行卡",
                        auth: APPLICATIONS.OCR_BANK_CARD.code
                    }
                ]
            }
        ]
    }
];
